import React, { Fragment, useEffect, useState } from 'react';
import { func, string } from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';
import classNames from 'classnames';

import {
  IconCalendarViewWeek, IconEditCalendar, IconTipsAndUpdates,
} from '../../../../components/Icons';
import {
  ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, ModalSwimmy,
} from '../../../../components/ModalSwimmy';
import { PrimaryButton, SecondaryButton } from '../../../../components';

import css from './AskForNextAvailabilitiesWarning.module.css';
import { useLocation } from 'react-router-dom';
import { parse } from '../../../../util/urlHelpers';

const AskForNextAvailabilitiesWarning = (props) => {
  const {
    className, intl, onManageDisableScrolling,
  } = props;
  const [isOpen, setIsOpen] = useState(!window.localStorage.getItem('calendarAskForNextAvailabilitiesWarningSeen'));
  const location = useLocation();
  const searchParams = parse(location.search) ?? {};
  const { fromAvailabilitiesPage } = searchParams;

  useEffect(() => {
    if (!fromAvailabilitiesPage) return;

    setIsOpen(true);
  }, [fromAvailabilitiesPage]);
  const handleSubmitClick = (e) => {
    window.localStorage.setItem('calendarAskForNextAvailabilitiesWarningSeen', 'true');
    setIsOpen(false);
  };
  const openButtonText = intl.formatMessage({ id: 'CalendarPage.AskForNextAvailabilitiesWarning.openButton' });
  const headingText = intl.formatMessage({ id: 'CalendarPage.AskForNextAvailabilitiesWarning.heading' });
  const planningHeadingText = intl.formatMessage({ id: 'CalendarPage.AskForNextAvailabilitiesWarning.planningHeading' });
  const planningInfoText = intl.formatMessage({ id: 'CalendarPage.AskForNextAvailabilitiesWarning.planningInfo' });
  const calendarHeadingText = intl.formatMessage({ id: 'CalendarPage.AskForNextAvailabilitiesWarning.calendarHeading' });
  const calendarInfoText = intl.formatMessage({ id: 'CalendarPage.AskForNextAvailabilitiesWarning.calendarInfo' });
  const tipsHeadingText = intl.formatMessage({ id: 'CalendarPage.AskForNextAvailabilitiesWarning.tipsHeading' });
  const tipsInfoText = intl.formatMessage({ id: 'CalendarPage.AskForNextAvailabilitiesWarning.tipsInfo' });
  const submitText = intl.formatMessage({ id: 'CalendarPage.AskForNextAvailabilitiesWarning.submit' });
  const classes = classNames(css.root, className);

  return (<Fragment>
      {/*<SecondaryButton className={classes} onClick={() => setIsOpen(true)}>*/}
      {/*  <span>{openButtonText}</span>*/}
      {/*</SecondaryButton>*/}
      <ModalSwimmy
        id="AskForNextAvailabilitiesWarning"
        animationType="fade"
        handleClickOutside={false}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <ModalOverlay />
        <ModalContent
          className={css.modalContent}
          animationType="slideBottom"
          show={isOpen}
        >
          <ModalHeader className={css.modalHeader}>
            <span className={css.heading}>{headingText}</span>
          </ModalHeader>
          <ModalBody className={css.modalBody}>
            <div className={css.headingWrapper}>
              <span className={css.sectionHeading}>{planningHeadingText}</span>
            </div>
            <section className={css.section}>
              <span className={css.info}>{planningInfoText}</span>
              <section className={css.cautionMessage}>
                <span className={css.info}>
                  <strong>
                  <FormattedMessage
                    id="CalendarPage.AskForNextAvailabilitiesWarning.planningWarning" /></strong>
                </span>
                <span className={css.info}>
                  <FormattedMessage
                    id="CalendarPage.AskForNextAvailabilitiesWarning.planningWarningDesc" />
                </span>
              </section>
              <span className={css.info}>
                <FormattedMessage id="CalendarPage.AskForNextAvailabilitiesWarning.planningInfo1" />
              </span>
              <span className={css.info}>
                <FormattedMessage id="CalendarPage.AskForNextAvailabilitiesWarning.planningInfo2" />
              </span>
              <span className={css.info}>
                <FormattedMessage id="CalendarPage.AskForNextAvailabilitiesWarning.thanks" />
              </span>
            </section>
          </ModalBody>
          <ModalFooter className={css.modalFooter}>
            <PrimaryButton
              className={css.submitButton}
              onClick={handleSubmitClick}
            >
              {submitText}
            </PrimaryButton>
          </ModalFooter>
        </ModalContent>
      </ModalSwimmy>
  </Fragment>);
};

AskForNextAvailabilitiesWarning.defaultProps = {
  className: null,
};

AskForNextAvailabilitiesWarning.propTypes = {
  className: string, intl: intlShape.isRequired, onManageDisableScrolling: func.isRequired,
};

export default AskForNextAvailabilitiesWarning;
